import { useDispatch } from 'react-redux';
import { useAppSelector } from 'app/config/store';
import React from 'react';
import { initCaseFormChange, setConfirmationChangeModalShow } from 'app/shared/reducers/case-form-change';
import { ConfirmationModal } from 'app/shared/modal/confirmation-modal';

const CaseChangeConfirmationWrapper = () => {
  const caseFormChange = useAppSelector(state => state.caseFormChange);
  const dispatch = useDispatch();

  const onConfirm = () => {
    if (caseFormChange.onConfirmCallbackFunction) {
      caseFormChange.onConfirmCallbackFunction();
    }

    dispatch(initCaseFormChange());
  };

  const onCancel = () => {
    if (caseFormChange.onRollbackCallbackFunction) {
      caseFormChange.onRollbackCallbackFunction();
    }

    dispatch(setConfirmationChangeModalShow(false));
  };

  return (
    <ConfirmationModal
      modalOpened={caseFormChange.confirmationChangeModalShow}
      header={'Nespremljene izmjene'}
      bodyMessage={'Imate nespremljene izmjene! Ako nastavite, promjene neće biti spremljene.'}
      confirmButtonLabel={'Nastavi'}
      cancelButtonLabel={'Odustani'}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default CaseChangeConfirmationWrapper;
